import React from 'react';
import PropTypes from 'prop-types';

import Link from '../../../../01_atoms/Link';
import { PTBBCarousel, PTBBCarouseSliderSettings } from '../prop-types.js';
import Button from '../../../../01_atoms/Button';
import Slider from '../../../../01_atoms/Slider';
import Spinner from '../../../../01_atoms/Spinner';
import DefaultPicture from '../../../../01_atoms/DefaultPicture';
import { generateClassNameByBehaviorSettings } from '../../../../../utils/behaviorSettings';

const BBCarouselMobile = ({
  items,
  sliderSettings,
  activeSlideIndex,
  transitioning,
  behaviorSettings,
  bbCarouselStyles,
  uuid,
}) => {
  const classes = [
    'bb',
    bbCarouselStyles['bb-carousel'],
    bbCarouselStyles['bb-carousel--mobile'],
    generateClassNameByBehaviorSettings(behaviorSettings),
  ];

  return (
    <div className={classes.join(' ')} id={uuid}>
      <Slider {...sliderSettings}>
        {items.map((item, i) => (
          <React.Fragment
            key={`${item.title}-${i}` /* eslint-disable-line react/no-array-index-key */}
          >
            {/* Image lazy loading is disabled due to some bug in react-slick & Chrome.
          See https://github.com/akiran/react-slick/pull/1954 and https://www.pivotaltracker.com/story/show/178381170 */}
            <DefaultPicture {...item.image} />

            <div
              style={{ width: `${100 / items.length}%` }}
              className={`${bbCarouselStyles['bb-carousel__gradient']} ${item.cta ? 'cta' : ''}`}
            >
              {item.cta && <h2 className="rockitt">{item.title}</h2>}
            </div>

            <div
              className={`${bbCarouselStyles['bb-carousel__overlay']} ${items[activeSlideIndex].cta ? 'cta' : ''}`}
            >
              <div className="container">
                {item.cta && item.cta.label && item.cta.nextLink ? (
                  <p>
                    <Link {...item.cta.nextLink}>
                      <Button
                        href={item.cta.nextLink.url}
                        tag="a"
                        isMobileBlock
                        className={bbCarouselStyles['bb-carousel__button']}
                      >
                        {item.cta.label}
                      </Button>
                    </Link>
                  </p>
                ) : (
                  <p>
                    <mark>
                      <b>{item.title}</b>
                    </mark>
                    <mark>{item.description}</mark>
                  </p>
                )}
              </div>
            </div>
          </React.Fragment>
        ))}
      </Slider>

      <div className={bbCarouselStyles['bb-carousel__counter']}>
        {transitioning ? (
          <Spinner />
        ) : (
          <mark>
            <strong>
              {activeSlideIndex + 1}/{items.length}
            </strong>
          </mark>
        )}
      </div>
    </div>
  );
};

BBCarouselMobile.propTypes = {
  ...PTBBCarousel,
  ...PTBBCarouseSliderSettings,
  activeSlideIndex: PropTypes.number.isRequired,
  transitioning: PropTypes.bool.isRequired,
};

export default BBCarouselMobile;
